import { render, staticRenderFns } from "./EditPlace.vue?vue&type=template&id=00091478&scoped=true&"
import script from "./EditPlace.vue?vue&type=script&lang=js&"
export * from "./EditPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00091478",
  null
  
)

export default component.exports